module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localModel),
      expression: "localModel"
    }],
    attrs: {
      "id": _vm.id,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localModel) ? _vm._i(_vm.localModel, null) > -1 : (_vm.localModel)
    },
    on: {
      "change": function (e) { return _vm.$emit('updateValue', e.target.checked); },
      "__c": function($event) {
        var $$a = _vm.localModel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.localModel = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.localModel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.localModel = $$c
        }
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f11f4fb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/CheckBox.vue
// module id = 3397
// module chunks = 0